import { fExecuteAPI } from "../../Server/Apis";
import {
  Bin_Attribute_GETROW,
  Bin_Load_GETROW,
  Bin_Save_GETROW,
} from "../../Server/ApiV2";
import {
  fAlertToast,
  fcovertToNumber,
  fcheck_null_undefine_replace_empty,
  Get_TransItemStockUOM,
} from "../../Utility/Utilitys";

import { Set_bin_HeadObject_Set } from "./Slicebin";

import { vRdxUserInfo, LoadingReceipt, BinRo } from "../../Redux/roStore";
import moment from "moment";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
 
// const { tax1, tax2 } = vRdxtax();
// const vRdxUserInfoObj = vRdxUserInfo();
// const { HeadObject } = LoadingReceipt();

var vheaderArrow = 0;
export const fRightClick = (e) => {
  vheaderArrow !== 1 ? (vheaderArrow = vheaderArrow + 1) : (vheaderArrow = 1);

  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

export const fLeftClick = (e) => {
  vheaderArrow !== 0 ? (vheaderArrow = vheaderArrow - 1) : (vheaderArrow = 0);
  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};
export const ErrorMsg = {
  Code: "",
  Aisle: "",
  Level: "",
  ShortDesc: "",
  Desc: "",
  Loc: "",
  Length: "",
  Width: "",
  Height: "",
  CBM: "",
  Type: "",
  LengthWastage: "",
  WidthWastage: "",
  HeightWastage: "",
  NoOfPallet: "",
  BinSize: "",
};

export const GridDataColumnsWmsSiDetail_Def = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "UId", headerName: "Code", width: 100 },
  { field: "AisleName", headerName: "Aisle", width: 100 },
  // { field: "Level", headerName: "Level", width: 300 },
  { field: "Name2", headerName: "ShortDesc", width: 100 },
  { field: "Name1", headerName: "Desc", width: 100 },
  { field: "LocName", headerName: "Location", width: 100 },
  { field: "Length", headerName: "Length", width: 100 },
  { field: "Width", headerName: "Width", width: 100 },
  { field: "Height", headerName: "Height", width: 100 },
  { field: "CBM", headerName: "CBM", width: 100 },
  { field: "LengthWastage", headerName: "LengthWastage", width: 100 },
  { field: "WidthWastage", headerName: "WidthWastage", width: 100 },
  { field: "HeightWastage", headerName: "HeightWastage", width: 100 },
  { field: "Pallet", headerName: "NoOfPallet", width: 100 },
  { field: "BinType", headerName: "Type", width: 100 },
  { field: "BinAttr1", headerName: "BinAttr1", width: 100 },
  { field: "BNSizeName", headerName: "BinSize", width: 100 },
];
export const GridDataColumnsItemSearch_Def = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "ItmCd", headerName: "ItmCd", width: 90 },
  { field: "Name1", headerName: "Name1", width: 450 },
  { field: "MainGrpName", headerName: "MainGrpName", width: 90 },
  { field: "SuppRefNo1", headerName: "SuppRefNo1", width: 90 },
  { field: "Model", headerName: "Model", width: 90 },
  { field: "BaseUnitName", headerName: "BaseUnitName", width: 90 },
  { field: "BarCode", headerName: "BarCode", width: 90 },
  { field: "NameFL", headerName: "NameFL", width: 90 },
];
//GCSearch
export const GridDataColumnsSearch_Def = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "VocName", headerName: "Doc.Name", width: 200 },
  { field: "A_VocNo", headerName: "Doc.No", width: 120 },
  {
    field: "A_VocDt",
    headerName: "Date",
    width: 90,
    valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
  },
  { field: "B_RefDocNo", headerName: "Ref.No", width: 100 },
  { field: "A_Party", headerName: "Party", width: 300, hide: true },
  { field: "LocName", headerName: "Location", width: 130 },
  { field: "A_Cluster", headerName: "Cluster", width: 90, hide: true },
  { field: "A_Trans", headerName: "Transaction", width: 150, hide: true },
  { field: "A_Truck", headerName: "Truck", width: 90, hide: true },
  { field: "A_Driver", headerName: "Driver", width: 90, hide: true },
  { field: "A_DocStat", headerName: "Status", width: 90, hide: true },
  { field: "A_TruckCBM", headerName: "Truck CBM", width: 90, hide: true },
  { field: "A_Tot_CBM", headerName: "Total CBM", width: 90, hide: true },
  { field: "A_Tot_Weight", headerName: "Total Weight", width: 90, hide: true },
];
export const ItemSearchData = [
  "Any",
  "Code",
  "Barcode",
  "Name",
  "RefNo",
  "NameFL",
];
export const vHeaderSearchInit = {
  AnyData: "",
  Name: "",
  Code: "",
};

export const sTrnTyp = "LDRECPT";
export const sStatusArr = ["ENTER", "POST", "DELETE", "DRAFT", "CANCEL"];

const fKeyLoadingReceipt = (event) => {
  // binContent
  const form = document.getElementById("binHead");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};

const fKeyLoadingReceiptContent = (event) => {
  // binContent
  const form = document.getElementById("binContent");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};

const fValidationHead_Client = (vRdxHead, setErrorMsg) => {
  let iRes = true;

  if (
    vRdxHead.Code === "" ||
    vRdxHead.Code === null ||
    vRdxHead.Code === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      Code: "Code should not be empty",
    }));
    fAlertToast("INFO", "Code should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.ShortDesc === "" ||
    vRdxHead.ShortDesc === null ||
    vRdxHead.ShortDesc === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      ShortDesc: "ShortDesc should not be empty",
    }));
    fAlertToast("INFO", "ShortDesc should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.Desc === "" ||
    vRdxHead.Desc === null ||
    vRdxHead.Desc === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      Desc: "Desc should not be empty",
    }));
    fAlertToast("INFO", "Desc should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.Loc === "" ||
    vRdxHead.Loc === null ||
    vRdxHead.Loc === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      Loc: "Loc should not be empty",
    }));
    fAlertToast("INFO", "Loc should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.Aisle === "" ||
    vRdxHead.Aisle === null ||
    vRdxHead.Aisle === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      Aisle: "Aisle should not be empty",
    }));
    fAlertToast("INFO", "Aisle should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.Length === "" ||
    vRdxHead.Length === null ||
    vRdxHead.Length === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      Length: "Length should not be empty",
    }));
    fAlertToast("INFO", "Length should not be empty");
    iRes = false;
  } else if (vRdxHead.Length == 0) {
    setErrorMsg((obj) => ({
      ...obj,
      Length: "Length should not be zero",
    }));
    fAlertToast("INFO", "Length should not be zero");
    iRes = false;
  }

  if (
    vRdxHead.Width === "" ||
    vRdxHead.Width === null ||
    vRdxHead.Width === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      Width: "Width should not be empty",
    }));
    fAlertToast("INFO", "Width should not be empty");
    iRes = false;
  } else if (vRdxHead.Width == 0) {
    setErrorMsg((obj) => ({
      ...obj,
      Width: "Width should not be zero",
    }));
    fAlertToast("INFO", "Width should not be zero");
    iRes = false;
  }

  if (
    vRdxHead.Height === "" ||
    vRdxHead.Height === null ||
    vRdxHead.Height === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      Height: "Height should not be empty",
    }));
    fAlertToast("INFO", "Height should not be empty");
    iRes = false;
  } else if (vRdxHead.Height == 0) {
    setErrorMsg((obj) => ({
      ...obj,
      Height: "Height should not be zero",
    }));
    fAlertToast("INFO", "Height should not be zero");
    iRes = false;
  }

  if (
    vRdxHead.NoOfPallet === "" ||
    vRdxHead.NoOfPallet === null ||
    vRdxHead.NoOfPallet === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      NoOfPallet: "NoOfPallet should not be empty",
    }));
    fAlertToast("INFO", "NoOfPallet should not be empty");
    iRes = false;
  } else if (vRdxHead.NoOfPallet == 0) {
    setErrorMsg((obj) => ({
      ...obj,
      NoOfPallet: "NoOfPallet should not be zero",
    }));
    fAlertToast("INFO", "NoOfPallet should not be zero");
    iRes = false;
  }

  return iRes;
};



//GCItemSearch
const GetItemSearch = async (
  xValue,
  xVendor,
  setGridSelectRowData,
  setGridSelectRowArr
) => {
  //openCustomer to call api on open modal if value in any data

  let sItemSearch = {
    v_AnyData: xValue,
    v_ItmCd: "",
    v_ItmName: "",
    v_Barcode: "",
    v_ModelSelectedValue: "",
    v_RefNo1: "",
    v_NameFc: "",
    v_CostPr: "",
    v_RSP: "",
    v_Catalogue: "",
    v_Br: "",
    v_RefNo3: "",
    v_Loc: "",
    v_Vendor: xVendor,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(sItemSearch);
  const vItemSearch = await fExecuteAPI("GRN_ITEMSEARCH_GETROW", FinalObj);
  if (vItemSearch.Status === 200) {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setGridSelectRowArr(vItemSearchArr);
    setGridSelectRowData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.Type.response.data.message
        ? vItemSearch.Type.response.data.message
        : "Error in ItemSearch"
    );
    return [];
  }
};

export const fBaseQtyCal = (B_PackQty, setBufferObj) => {
  let B_BaseQty = fcovertToNumber(B_PackQty);
  setBufferObj((obj) => ({
    ...obj,
    B_BaseQty: B_BaseQty,
  }));
};

const GetSearchItem = async (xData, xType, xA_Loc, setSearchGridData) => {
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSeatchVendor);
  const vItemSearch = await fExecuteAPI("SEARCHITEM001_GETROW", FinalObj);
  if (vItemSearch.Type == "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in SearchItem"
    );
  }
};

const fLoad_Grid = async (setDetailGridData) => {
  const iSIDetail = await GetSIDetail();
  if (iSIDetail.length > 0) {
    let GridID = iSIDetail?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setDetailGridData(GridID);
  } else {
    setDetailGridData([]);
  }
};

//HEAD LOADING API
// Api

// Checkbox_Rights_GETROW
const GetCheckboxUserRights = async (dispatch) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const vCheckBoxRightsObj = {
    usercd: vRdxUserInfoObj.UserID,
    usergrp: vRdxUserInfoObj.UserGroupCode,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vCheckBoxRightsObj);
  const vCheckBoxRights = await fExecuteAPI(
    "Checkbox_User_Rights_GETROW",
    FinalObj
  );
  if (vCheckBoxRights?.Type?.toUpperCase() === "SUCCESS") {
    return vCheckBoxRights?.ResultSet;
  } else {
    fAlertToast(
      "FAILED",
      vCheckBoxRights?.response?.data?.message
        ? vCheckBoxRights?.response?.data?.message
        : "Error in CheckBoxRights"
    );
    return [];
  }
};

//API Unit GETITEMUNITSINBOUND_GETROW
const GetUnitArr = async (xItemCode, setUnit) => {
  let itemUnitobj = {
    itemCd: xItemCode,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(itemUnitobj);

  const UnitInfo = await fExecuteAPI("GETITEMUNITS_GETROW", FinalObj);
  if (UnitInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitInfo.ResultSet.length > 0) {
      setUnit(UnitInfo.ResultSet);
      return UnitInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitInfo.Type.response.data.message
        ? UnitInfo.Type.response.data.message
        : "Error in UnitArr"
    );
    return [];
  }
};

//API
const GetItemFullSearchArr = async (xItemName, xLoc) => {
  let vItemFullSearchDataObj = {
    anyData: xItemName,
    transType: "F",
    report: "Y",
    loc: xLoc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemFullSearchDataObj);

  const vItemSearchFull = await fExecuteAPI(
    // "ITEM_SEARCHFULL_GETROW",
    "SEARCHEXACTITEM_GETROW",
    FinalObj
  );
  //status code "" so Success is checked
  if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
    if (vItemSearchFull.ResultSet.length > 0) {
      return vItemSearchFull.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vItemSearchFull.Type.response.data.message
        ? vItemSearchFull.Type.response.data.message
        : "Error in vItemSearchFullArr"
    );
    return [];
  }
};

//API GETSIDETAILS_GETROW
const GetSIDetail = async () => {
  const { HeadObject } = BinRo();
  let iSIDetailObj = {
    v_Typ: "A",
    v_Data: "",
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);
  const iSIDetailResult = await Bin_Load_GETROW(FinalObj);
  if (iSIDetailResult?.status == 200) {
    if (iSIDetailResult.data.ResultSet.length > 0) {
      return iSIDetailResult.data.ResultSet;
    } else {
      return [];
    }
  }
};

//API SaveSIHead
const fSaveHead = async (fNewDetail) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObject } = BinRo();
  let vSaveSIHeadObj = {
    v_UId: HeadObject.Code,
    v_Name1: HeadObject.Desc,
    v_Name2: HeadObject.ShortDesc,
    v_Loc: HeadObject.Loc,
    v_AisleCd: HeadObject.Aisle,
    v_UserCd: vRdxUserInfoObj.UserID,
    v_Length: HeadObject.Length,
    v_Width: HeadObject.Width,
    v_Height: HeadObject.Height,
    v_LengthWastage: HeadObject.LengthWastage,
    v_WidthWastage: HeadObject.WidthWastage,
    v_HeightWastage: HeadObject.HeightWastage,
    v_CBM: HeadObject.CBM,
    v_BinType: HeadObject.Level,
    v_Pallet: HeadObject.NoOfPallet,
    v_BinAttr1: HeadObject.Type,
    v_BNSize: HeadObject.BinSize,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);

  const vSaveSIHead = await Bin_Save_GETROW(FinalObj);
  if (vSaveSIHead?.status === 200) {
    // eslint-disable-next-line eqeqeq

    fNewDetail();
    fAlertToast("SUCCESS", "Successfully Saved");
  }
};

const fApproveLoadingReceipt = async (dispatch, fNewDetail) => {
  const { HeadObject } = LoadingReceipt();
  const vRdxUserInfoObj = vRdxUserInfo();
  let vSaveSIHeadObj = {
    VocTyp: HeadObject?.A_VocTyp,
    VocNo: HeadObject?.A_VocNo,
    ip: vRdxUserInfoObj.IP,
    usercd: vRdxUserInfoObj.UserID,
    Loc: HeadObject?.A_Loc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);

  const vSaveSIHead = await fExecuteAPI(
    "LoadingReceipt_Approve_GETROW",
    FinalObj
  );
  if (vSaveSIHead?.Type?.toUpperCase() === "SUCCESS") {
    fDisplay(HeadObject.A_VocTyp, HeadObject.A_VocNo, dispatch, fNewDetail);

    fAlertToast("SUCCESS", "Successfully posted");
  } else {
    fAlertToast(
      "FAILED",
      !!vSaveSIHead.response.data.message
        ? vSaveSIHead?.response?.data?.message
        : "Fail to Save Head"
    );
  }
};
//API GETSIHEAD_GETROW to gethead
const fDisplay = async (xA_VocTyp, A_VocNo, dispatch, fNewDetail) => {
  const { HeadObject } = LoadingReceipt();
  let vSIHeadObj = {
    VocTyp: xA_VocTyp,
    VocNo: A_VocNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSIHeadObj);
  const vSIHead = await fExecuteAPI("LoadingReceipt_fDisplay_GETROW", FinalObj);

  if (vSIHead?.Type?.toUpperCase() === "SUCCESS") {
    dispatch(
      Set_bin_HeadObject_Set({
        ...HeadObject,
        A_VocTyp: vSIHead.ResultSet[0].A_VocTyp,
        A_VocTypName: vSIHead.ResultSet[0].VocName,
        A_VocNo: vSIHead.ResultSet[0].A_VocNo,
        A_PostDt: vSIHead.ResultSet[0].A_VocDt,
        A_ReceiptDt: vSIHead.ResultSet[0].A_DO_RCVD_DT,
        A_Loc: vSIHead.ResultSet[0].A_DO_RCVD_Loc,
        A_DocStat: vSIHead.ResultSet[0].A_DO_RCVD_STATUS,
        Truck: vSIHead.ResultSet[0].TruckName,
        Driver: vSIHead.ResultSet[0].A_Driver,
      })
    );

    fNewDetail(vSIHead.ResultSet[0].A_VocNo, vSIHead.ResultSet[0].A_VocTyp);
  }
};

export const GetAttributes = async (setAttribute) => {
  // const vRdxUserInfoObj = vRdxUserInfo();
  // var vObj = {
  //   userCode: vRdxUserInfoObj.UserID,
  //   userGroupCode: vRdxUserInfoObj.UserGroupCode,
  // };
  const iAttributes = await Bin_Attribute_GETROW({});
  if (iAttributes?.status === 200) {
    setAttribute(iAttributes?.data?.ResultSet);

    return iAttributes?.data?.ResultSet;
  } else {
    setAttribute({
      Location: [],
      aisle: [],
      level: [],
      binType: [],
    });
    return [];
  }
};
export const getTransItemStockUOM = async (
  setTransItemStockObj,
  xB_Itmcd,
  xB_Unit,
  xLoc
) => {
  let ApiObj = await Get_TransItemStockUOM(xB_Itmcd, xB_Unit, xLoc);
  if (ApiObj?.length > 0) {
    setTransItemStockObj({
      RPStock: ApiObj[0]?.RPStock,
      MSP: ApiObj[0].MSP,
      CostPr: ApiObj[0].CostPr,
      LPRate: ApiObj[0].LPRate,
    });
  }
};
export {
  // rows,
  // columns,
  fKeyLoadingReceipt,
  fKeyLoadingReceiptContent,
  // Api
  GetCheckboxUserRights,
  GetUnitArr,
  GetItemFullSearchArr,
  GetItemSearch,
  GetSearchItem,
  //save
  fValidationHead_Client,
  fLoad_Grid,
  fSaveHead,
  fDisplay,
  fApproveLoadingReceipt,
};
